// import React, { useState, useEffect } from 'react';
// import { X, Sparkles, Zap, FileText, Settings } from 'lucide-react';

// const UpdatesPopup = ({ isOpen, onClose }) => {
//     const [currentUpdateIndex, setCurrentUpdateIndex] = useState(0);

//     // Sample updates data - you can modify this to fetch from an API or config
//     const updates = [
//         {
//             id: 1,
//             version: "v2.1.0",
//             date: "September 10, 2025",
//             type: "feature",
//             icon: <Sparkles className="text-blue-500" size={24} />,
//             title: "Image Generation For ALL Models",
//             description: "Image refinement capabilities with all models within the platform",
//             highlights: [
//                 "Image Generation with research models",
//                 "Image Generation with reasoning models",
//             ]
//         },
//         {
//             id: 2,
//             version: "v1.1.0",
//             date: "September 1, 2025",
//             type: "improvement",
//             icon: <Zap className="text-yellow-500" size={24} />,
//             title: "Expanded Model Support",
//             description: "Introduced OpenAI Deep Research models with faster performance and better handling of complex queries.",
//             highlights: [
//                 "Added o3-deep-research and o4-mini-deep-research models from OpenAI Deep Research Series",
//                 "Improved response speed and streaming consistency",
//             ]
//         },
//     ];

//     const currentUpdate = updates[currentUpdateIndex];

//     // Don't render if not open
//     if (!isOpen) return null;

//     const handleNext = () => {
//         setCurrentUpdateIndex((prev) => (prev + 1) % updates.length);
//     };

//     const handlePrev = () => {
//         setCurrentUpdateIndex((prev) => (prev - 1 + updates.length) % updates.length);
//     };

//     const getTypeColor = (type) => {
//         switch (type) {
//             case 'feature': return 'bg-blue-500';
//             case 'improvement': return 'bg-yellow-500';
//             case 'fix': return 'bg-red-500';
//             default: return 'bg-gray-500';
//         }
//     };

//     return (
//         <div className={`fixed inset-0 flex items-center justify-center z-50 p-4
//    transition-opacity duration-300 ${isOpen ? "opacity-100 bg-black bg-opacity-50" : "opacity-0 pointer-events-none"}`}>
//             <div className={`bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden
//    transform transition-all duration-500 ease-in-out
//    ${isOpen ? "scale-100 opacity-100" : "scale-95 opacity-0"}`}>
//                 {/* Header */}
//                 <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6 relative">
//                     <button
//                         onClick={onClose}
//                         className="absolute top-4 right-4 text-white hover:text-gray-200 transition-colors"
//                         aria-label="Close updates"
//                     >
//                         <X size={24} />
//                     </button>

//                     <div className="flex items-center gap-3">
//                         <Sparkles size={32} className="text-yellow-300" />
//                         <div>
//                             <h2 className="text-2xl font-bold">What's New</h2>
//                             <p className="text-blue-100">Latest updates and improvements</p>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Content */}
//                 <div className="p-6">
//                     {/* Update indicator dots */}
//                     <div className="flex justify-center gap-2 mb-6">
//                         {updates.map((_, index) => (
//                             <button
//                                 key={index}
//                                 onClick={() => setCurrentUpdateIndex(index)}
//                                 className={`w-3 h-3 rounded-full transition-all ${index === currentUpdateIndex
//                                         ? 'bg-blue-500 scale-125'
//                                         : 'bg-gray-300 hover:bg-gray-400'
//                                     }`}
//                             />
//                         ))}
//                     </div>

//                     {/* Current update */}
//                     <div className="text-center mb-6">
//                         <div className="flex items-center justify-center gap-3 mb-4">
//                             {currentUpdate.icon}
//                             <div>
//                                 <div className="flex items-center gap-2 justify-center mb-1">
//                                     <span className={`px-2 py-1 rounded-full text-xs font-semibold text-white ${getTypeColor(currentUpdate.type)}`}>
//                                         {currentUpdate.type.toUpperCase()}
//                                     </span>
//                                     <span className="text-sm text-gray-500">{currentUpdate.version}</span>
//                                 </div>
//                                 <h3 className="text-xl font-bold text-gray-800">{currentUpdate.title}</h3>
//                                 <p className="text-sm text-gray-500">{currentUpdate.date}</p>
//                             </div>
//                         </div>

//                         <p className="text-gray-600 mb-4 leading-relaxed">
//                             {currentUpdate.description}
//                         </p>

//                         {/* Highlights */}
//                         <div className="bg-gray-50 rounded-lg p-4 mb-4">
//                             <h4 className="font-semibold text-gray-800 mb-3">Key Highlights:</h4>
//                             <ul className="text-left space-y-2">
//                                 {currentUpdate.highlights.map((highlight, index) => (
//                                     <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
//                                         <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
//                                         {highlight}
//                                     </li>
//                                 ))}
//                             </ul>
//                         </div>
//                     </div>

//                     {/* Navigation */}
//                     <div className="flex justify-between items-center">
//                         <button
//                             onClick={handlePrev}
//                             disabled={updates.length <= 1}
//                             className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                         >
//                             Previous
//                         </button>

//                         <span className="text-sm text-gray-500">
//                             {currentUpdateIndex + 1} of {updates.length}
//                         </span>

//                         <button
//                             onClick={handleNext}
//                             disabled={updates.length <= 1}
//                             className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                         >
//                             Next
//                         </button>
//                     </div>
//                 </div>

//                 {/* Footer */}
//                 <div className="bg-gray-50 px-6 py-4 border-t">
//                     <div className="flex justify-between items-center">
//                         <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer hidden ">
//                             <input
//                                 type="checkbox"
//                                 className="rounded"
//                                 onChange={(e) => {
//                                     // You can implement logic to remember user preference
//                                     if (e.target.checked) {
//                                         localStorage.setItem('hideUpdatesPopup', 'true');
//                                     } else {
//                                         localStorage.removeItem('hideUpdatesPopup');
//                                     }
//                                 }}
//                             />
//                             Don't show this again
//                         </label>

//                         <button
//                             onClick={onClose}
//                             className="ml-auto px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold"
//                         >
//                             Got it!
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // Hook to manage updates popup state
// export const useUpdatesPopup = () => {
//     const [isUpdatesOpen, setIsUpdatesOpen] = useState(false);

//     useEffect(() => {
//         // Check if user has dismissed the popup
//         const hasHiddenPopup = localStorage.getItem('hideUpdatesPopup');
//         const lastShownVersion = localStorage.getItem('lastShownUpdateVersion');
//         const currentVersion = 'v2.4.0'; // Update this when you have new updates

//         // Show popup if user hasn't hidden it and hasn't seen the current version
//         if (!hasHiddenPopup && lastShownVersion !== currentVersion) {
//             // Show popup after a short delay for better UX
//             const timer = setTimeout(() => {
//                 setIsUpdatesOpen(true);
//             }, 1000);

//             return () => clearTimeout(timer);
//         }
//     }, []);

//     const closeUpdatesPopup = () => {
//         setIsUpdatesOpen(false);
//         // Remember that user has seen this version
//         localStorage.setItem('lastShownUpdateVersion', 'v2.4.0');
//     };

//     return {
//         isUpdatesOpen,
//         closeUpdatesPopup
//     };
// };

// export default UpdatesPopup;

import React, { useState, useEffect } from "react";
import { X, Sparkles } from "lucide-react";

const UpdatesPopup = ({ isOpen, onClose }) => {
  const [currentUpdateIndex, setCurrentUpdateIndex] = useState(0);

  const updates = [
    {
      id: 1,
      version: "v2.1.0",
      date: "September 10, 2025",
      type: "feature",
      title: "Image Generation For ALL Models",
      description: "Image refinement capabilities with all models.",
      highlights: [
        "Image Generation with research models",
        "Image Generation with reasoning models",
      ],
    },
    {
      id: 2,
      version: "v1.1.0",
      date: "September 1, 2025",
      type: "improvement",
      title: "Expanded Model Support",
      description: "Introduced OpenAI Deep Research models.",
      highlights: [
        "Added o3-deep-research and o4-mini-deep-research",
        "Improved response speed",
      ],
    },
  ];

  const currentUpdate = updates[currentUpdateIndex];
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center transition-all duration-500 ease-[cubic-bezier(0.22,0.61,0.36,1)] ${
        isOpen ? "opacity-100 bg-black/70" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        className={`relative w-[90%] mx-auto max-w-lg transform rounded-2xl bg-[#1e1e1e] p-6 text-white shadow-2xl transition-all duration-500 ease-in-out ${
          isOpen ? "scale-100" : "scale-95 opacity-0"
        } font-sans antialiased text-[15px] leading-relaxed`}
      >
        {/* Close (audio-style): small padding, rounded, gray → white text, subtle dark hover bg, no ring */}
        <button
          onClick={onClose}
          aria-label="Close updates"
          className="absolute right-4 top-4 select-none rounded-[4px] p-1 text-[#dcdcdc] hover:bg-[#333] hover:text-white
                     focus:outline-none focus-visible:outline-none active:outline-none ring-0"
        >
          <X size={20} />
        </button>

        {/* Header */}
        <div className="mb-4 flex items-center gap-2">
          <Sparkles className="text-yellow-400" />
          <h2 className="text-2xl font-semibold leading-tight tracking-tight">
            What's New
          </h2>
        </div>

        {/* Content */}
        <div className="space-y-3">
          <h3 className="text-lg font-semibold leading-tight">
            {currentUpdate.title}
          </h3>
          <p className="text-sm text-gray-300">
            {currentUpdate.date} • {currentUpdate.version}
          </p>
          <p className="text-gray-300">{currentUpdate.description}</p>

          <ul className="list-inside list-disc text-sm text-gray-400">
            {currentUpdate.highlights.map((h, i) => (
              <li key={i}>{h}</li>
            ))}
          </ul>
        </div>

        {/* Navigation */}
        <div className="mt-6 grid grid-cols-[auto_1fr_auto] items-center gap-3">
          {/* Link-style: always underlined; only text/underline turn blue on hover; no outline */}
          <button
            onClick={() =>
              setCurrentUpdateIndex(
                (prev) => (prev - 1 + updates.length) % updates.length
              )
            }
            className="bg-transparent p-0 text-white underline underline-offset-2 decoration-current
                       hover:text-blue-400 focus:outline-none active:outline-none disabled:opacity-40 disabled:pointer-events-none"
          >
            Previous
          </button>

          <span className="justify-self-center text-sm text-gray-400">
            {currentUpdateIndex + 1} of {updates.length}
          </span>

          <button
            onClick={() =>
              setCurrentUpdateIndex(
                (prev) => (prev + 1) % updates.length
              )
            }
            className="bg-transparent p-0 text-white underline underline-offset-2 decoration-current
                       hover:text-blue-400 focus:outline-none active:outline-none disabled:opacity-40 disabled:pointer-events-none"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatesPopup;
